import { NavigationContainerRefContext } from '@react-navigation/core';
import { NavigationRouteContext } from '@react-navigation/native';
import React, { useEffect, useState } from 'react';
import { navigationRef } from './NavigationWrapper';
/**
 * Fallback route used before the navigator is ready (or when no route is
 * focused yet). It keeps `useRoute()` from throwing inside helper views and
 * resolves to "no params", which is a safe default for consumers like
 * pagination (offset/limit fall back to their defaults).
 */
const FALLBACK_ROUTE = {
    key: 'helper-view-root',
    name: 'HelperViewRoot',
    params: undefined,
};
function getActiveRoute() {
    if (navigationRef.isReady()) {
        return (navigationRef.getCurrentRoute() ??
            FALLBACK_ROUTE);
    }
    return FALLBACK_ROUTE;
}
/**
 * Proxies navigation contexts into helper views that sit outside
 * `NavigationContainer` as a sibling of the navigator.
 *
 * - `NavigationRouteContext` — mirrors the focused route so `useRoute()` works
 *   (e.g. pagination in overlay/drawer content).
 * - `NavigationContainerRefContext` — exposes `navigationRef` so `useLinkTo` /
 *   `Pressable` `to` presses can navigate.
 */
const ProxyNavigationWrapper = ({ children, }) => {
    const [route, setRoute] = useState(getActiveRoute);
    useEffect(() => {
        const sync = () => setRoute(getActiveRoute());
        // Sync immediately in case the navigator became ready between the initial
        // render and this effect running.
        sync();
        return navigationRef.addListener('state', sync);
    }, []);
    return (React.createElement(NavigationContainerRefContext.Provider, { value: navigationRef },
        React.createElement(NavigationRouteContext.Provider, { value: route }, children)));
};
export default ProxyNavigationWrapper;
